var _circle, _circle2, _circle3, _circle4, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEntertainment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9811,
    cy: 51.9811,
    r: 51.9811,
    fill: "#314DD8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9811,
    cy: 51.9811,
    r: 51.9811,
    fill: "#22FFAA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2819,
    cy: 45.8288,
    r: 33.3478,
    fill: "#00E98F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_28813",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 104
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9811,
    cy: 51.9811,
    r: 51.9811,
    fill: "#22FFAA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_28813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7678 52.3511C58.9792 44.4985 63.3234 27.4227 55.4708 14.2113C47.6182 0.999892 30.5425 -3.34431 17.3311 4.50827C4.11964 12.3609 -0.22456 29.4366 7.62802 42.648C15.4806 55.8594 32.5563 60.2036 45.7678 52.3511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6819 16.0525C47.1437 15.9575 43.2998 16.1378 40.3031 16.5876C38.7636 16.8155 33.4828 18.4082 32.9884 18.5517C32.4939 18.6953 31.7478 18.4516 31.0386 18.4867C30.3357 18.4964 29.6191 18.772 29.1131 18.6433C28.6007 18.5399 23.269 17.1565 21.7184 17.0045C18.6995 16.6944 14.85 16.6848 13.3298 16.8367C10.6252 17.0915 6.97496 17.8868 6.65761 18.0754C6.34025 18.264 6.75097 21.5201 6.75097 21.5201C6.75097 21.5201 7.45935 21.7003 7.7372 21.8788C8.01504 22.0572 8.3932 22.4767 8.39696 23.0972C8.40072 23.7177 9.27625 32.4524 15.4125 33.7442C16.8991 34.0416 20.2371 33.7325 20.2371 33.7325C20.2371 33.7325 24.8488 33.1818 26.972 29.6006C28.158 27.5858 29.0584 25.7407 29.7364 22.5461C29.8077 22.1602 30.3601 21.7889 31.1517 21.7479C31.9304 21.7574 32.4861 22.1143 32.5795 22.4882C33.3895 25.6574 34.3635 27.4405 35.6659 29.415C37.9308 32.9004 42.5577 33.2425 42.5577 33.2425C42.5577 33.2425 45.9317 33.4274 47.3769 33.0409C53.4552 31.4895 53.9348 22.7224 53.9057 22.0954C53.8766 21.4685 54.233 21.0204 54.5187 20.8507C54.779 20.6745 55.4827 20.4494 55.4827 20.4494C55.4827 20.4494 55.7495 17.1771 55.4147 17.0111C55.0862 16.8198 51.3912 16.203 48.6819 16.0525Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1417 53.3272C17.2611 53.6898 4.83527 42.2859 3.7437 27.6239C3.72904 28.105 3.73968 28.5926 3.75033 29.0802C4.09821 44.4419 16.8438 56.6005 32.2055 56.2526C47.5672 55.9048 59.7259 43.1592 59.378 27.7975C59.3673 27.3099 59.3314 26.8159 59.3143 26.3536C58.8926 41.0346 47.0158 52.99 32.1417 53.3272Z",
    fill: "#F2F4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8609 41.6192C26.9599 41.7192 21.2753 39.9228 16.8684 36.916C16.5211 36.693 16.1771 37.1981 16.4481 37.5095C20.3037 42.1538 26.6734 45.175 31.9607 45.0386C37.2417 44.9275 43.473 41.6103 47.0956 36.7944C47.3439 36.4535 46.9851 35.9582 46.6484 36.2227C42.3549 39.4403 36.7684 41.4939 31.8609 41.6192Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7599 102.96C44.5347 102.96 54.0799 93.4148 54.0799 81.6401C54.0799 69.8654 44.5347 60.3201 32.7599 60.3201C20.9852 60.3201 11.4399 69.8654 11.4399 81.6401C11.4399 93.4148 20.9852 102.96 32.7599 102.96Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7599 100.72C21.3599 100.72 12.0599 91.7803 11.4599 80.5203C11.4399 80.9003 11.4399 81.2603 11.4399 81.6403C11.4399 93.4203 20.9799 102.96 32.7599 102.96C44.5399 102.96 54.0799 93.4203 54.0799 81.6403C54.0799 81.2603 54.0799 80.9003 54.0599 80.5203C53.4599 91.7803 44.1599 100.72 32.7599 100.72Z",
    fill: "#2E293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3801 85.4602C46.3801 91.4002 38.7001 96.2202 32.7601 96.2202C26.8201 96.2202 19.1401 91.4002 19.1401 85.4602C19.4801 81.7402 46.2601 81.7402 46.3801 85.4602Z",
    fill: "#2E293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6401 93.0002C26.3201 94.9802 29.7601 96.2002 32.7601 96.2002C37.1001 96.2002 42.3601 93.6402 44.8801 89.9402C42.5201 88.6202 39.4001 87.8202 36.0001 87.8202C30.4201 87.8202 25.6601 89.9602 23.6401 93.0002Z",
    fill: "#22FFAA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M23.6401 93.0002C24.2801 93.4802 24.9601 93.9002 25.6601 94.2802C30.4801 88.5802 41.3801 88.5402 44.8801 89.9402C42.5201 88.6202 39.4001 87.8202 36.0001 87.8202C30.4201 87.8202 25.6601 89.9602 23.6401 93.0002Z",
    fill: "#22FFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.04 75.9405C36.9001 73.9404 38.8202 72.4803 41.1604 72.3203C44.4406 72.1202 47.2808 74.6004 47.5008 77.9006",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4813 75.9412C28.6212 73.9411 26.7011 72.481 24.3609 72.321C21.0807 72.121 18.2405 74.6211 18.0205 77.9013",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9725 75.0923C107.585 65.4803 107.585 49.8962 97.9725 40.2841C88.3605 30.6721 72.7764 30.6721 63.1643 40.2841C53.5523 49.8962 53.5523 65.4803 63.1643 75.0923C72.7764 84.7043 88.3605 84.7043 97.9725 75.0923Z",
    fill: "#435CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9152 79.7152C67.7543 79.923 56.833 69.7636 55.9556 56.7874C55.9556 57.2261 55.9556 57.6417 55.9556 58.0804C56.1865 71.68 67.3617 82.509 80.9614 82.3012C94.5611 82.0703 105.39 70.895 105.182 57.2953C105.182 56.8566 105.159 56.441 105.136 56.0023C104.674 69.0017 94.0762 79.5074 80.9152 79.7152Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.73 61.6822C94.8383 61.3821 95.3924 63.2754 95.1153 64.3837C93.7761 69.879 86.5953 74.1736 80.8461 74.266C75.143 74.3583 67.8929 70.3638 66.2997 64.984C65.9534 63.8065 66.4383 61.8438 67.6389 62.0978C74.635 63.5986 86.5722 63.6448 93.73 61.6822Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0244 62.3517C69.8325 64.1295 72.4417 66.9695 80.7308 66.831C88.9506 66.6925 91.4904 63.8063 92.2755 62.0053C85.5334 63.5292 75.628 63.5061 69.0244 62.3517Z",
    fill: "#F2F4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9314 46.7202L84.4712 52.1004L95.6242 55.7949",
    stroke: "#060C23",
    strokeWidth: 2.08014,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3227 47.1819L76.9446 52.2157L65.9302 56.2797",
    stroke: "#060C23",
    strokeWidth: 2.08014,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8462 74.2657C82.9473 74.2426 85.2562 73.6192 87.4035 72.6033C85.972 70.8023 82.2777 69.1168 77.7983 68.4472C74.1271 67.893 70.7792 68.1008 68.6318 68.909C71.6335 72.1877 76.6439 74.335 80.8462 74.2657Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2261 71.5181C84.4021 70.1558 81.3312 68.9782 77.7754 68.4472C74.1042 67.893 70.7562 68.1008 68.6089 68.909C69.3247 69.6709 70.1328 70.3867 71.0333 71.0101C73.55 70.479 81.4697 70.1096 86.2261 71.5181Z",
    fill: "#243CBB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9734 6.81565C70.5349 8.70666 80.1786 14.185 87.2063 22.2783M93.8576 32.309C92.9591 30.4768 91.9493 28.7218 90.8392 27.0503",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5887 97.3423C64.0143 96.5392 68.1814 95.1393 72.0222 93.2406C73.6971 92.4126 75.31 91.4897 76.8552 90.4801",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntertainment);
export default __webpack_public_path__ + "static/media/entertainment.24cc2e8cea5993c564181d9e9db465a4.svg";
export { ForwardRef as ReactComponent };